module.exports = __webpack_public_path__ + "img/mate10pro.00722d57.jpg";